import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchAgreementList } from '../actions/companyActions'

const useFetchingAgreement = ({ company }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchAgreementList(company))
  }, [dispatch, company])
}

export default useFetchingAgreement
